import React, { useState, useEffect } from 'react';
import MainScreen from '../../components/interview/main_screen/MainScreen';
import SpeechToText from '../../components/interview/chat_history/speech-to-text';
import Footer from '../../components/interview/footer/Footer';
import WaitingRoom from '../../components/interview/waiting_room/WaitingRoom';
import CreateInterview from '../create_interview/CreateInterview';
import CompleteInterview from '../../components/interview/complete_interview/CompleteInterview';
import { useInterval } from '../../utils/useInterval';
import { TopBar } from '../../components/top_bar/TopBar';
import { GetUser } from '../../components/auth/GetUser';
import { useUser } from '@clerk/clerk-react';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import posthog from 'posthog-js';


const Interview = () => {
    const [globalResume, setGlobalResume] = useState("");
    const [globalJD, setGlobalJD] = useState("");
    const [globalRound, setGlobalRound] = useState("");
    const [mic, setMic] = useState(false);
    const [video, setVideo] = useState(false);
    const [cc, setCc] = useState(false);
    const [language, setLanguage] = useState("en");
    const [isIntvSpeaking, setIsIntvSpeaking] = useState(false);
    const [isCandSpeaking, setIsCandSpeaking] = useState(false);
    const [hasUserJoined, setHasUserJoined] = useState(false);
    const [hasEndButtonClicked, setEndButtonClicked] = useState(false);
    const [interviewPromptId, setInterviewPromptId] = useState("");
    const [interviewQuestion, setInterviewQuestion] = useState("");
    const [joinTime, setJoinTime] = useState(null);


    const { isSignedIn, user, isLoaded } = useUser()
    const [candidateEmail, setCandidateEmail] = useState("");
    const [candidateFirstName, setCandidateFirstName] = useState("Candidate");
    const [candidateLastName, setCandidateLastName] = useState("Candidate");
    const [hasTwoInterviewsThisMonth, setHasTwoInterviewsThisMonth] = useState(false);
    const [isPremium, setIsPremium] = useState(false);
    const [subscriptionLevel, setSubscriptionLevel] = useState('Free Starter');
    const [candidateImg, setCandidateImg] = useState("");
    const [quickMockJobId, setQuickMockJobId] = useState("");
    const [jT, setJT] = useState("");
    const [cN, setCN] = useState("");
    const [agentId, setAgentId] = useState("");
    const [jobId, setJobId] = useState(null);
    const [partner, setPartner] = useState(null);

    // B2B specific states
    const [isB2BInterview, setIsB2BInterview] = useState(false);
    const [jobListingId, setJobListingId] = useState(null);

    // Practice mode specific states
    const [isPracticeMode, setIsPracticeMode] = useState(false);
    const [practiceQuestionId, setPracticeQuestionId] = useState(null);
    const [practiceQuestion, setPracticeQuestion] = useState(null);

    const [sessionId, setSessionId] = useState(null);
    const [jobDataReady, setJobDataReady] = useState(false);

    const TITLE = 'Interview - Mirwork';

    const updateURLWithQMJid = (QMJid, agentId = null) => {
        const url = new URL(window.location);

        url.searchParams.delete('sessionId');
        url.searchParams.delete('QMJid');

        // const otherParams = url.searchParams.toString();
        url.searchParams.set('QMJid', QMJid);
        if (agentId) {
            url.searchParams.set('agentId', agentId);
        }

        const newUrl = `${url.origin}${url.pathname}?${url.searchParams.toString()}`;

        window.history.replaceState({}, '', newUrl);
    };

    const handlePracticeMode = async () => {
        try {
            const urlParams = new URLSearchParams(window.location.search);
            const questionId = urlParams.get('questionId');
            const company = urlParams.get('company');
            const type = urlParams.get('type');


            if (!questionId) {
                alert('Practice question ID is missing. Please try again.');
                return;
            }

            // Fetch the practice question details
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/questionBank/questions/${questionId}`);

            if (response.data.success) {
                const question = response.data.data;
                setPracticeQuestion(question);

                // Set interview data based on the practice question
                setGlobalJD(`Practice Interview\n\nCompany: ${question.company}\nPosition: ${question.jobTitle}\nInterview Type: ${question.interviewType}\nDifficulty: ${question.difficulty}\n\nYou will be practicing this real interview question from ${question.company}.`);
                setGlobalRound(question.standardizedQuestionType || 'practice');
                setJT(question.jobTitle || 'Practice Interview');
                setCN(question.company || 'Practice Company');
                setInterviewQuestion(question.interviewQuestion);

                // Mark as ready for interview
                setJobDataReady(true);

            } else {
                throw new Error('Failed to fetch question details');
            }
        } catch (error) {
            console.error('Error initializing Practice mode:', error);
            alert('Failed to load practice question. Please try again.');
        }
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const agentIdParam = urlParams.get('agentId');
        if (agentIdParam && !agentId) {
            setAgentId(agentIdParam);
        }

        // Check for B2B interview parameters
        const jobListingParam = urlParams.get('joblisting');

        if (jobListingParam) {
            setIsB2BInterview(true);
            setJobListingId(jobListingParam);
        }

        // Check for Practice mode parameters
        const modeParam = urlParams.get('mode');
        const questionIdParam = urlParams.get('questionId');
        const originalQuestionIdParam = urlParams.get('originalQuestionId');
        if ((modeParam === 'practice' && questionIdParam) || (modeParam === 'followup' && originalQuestionIdParam)) {
            setIsPracticeMode(true);
            // For followup mode, use the original question ID
            setPracticeQuestionId(questionIdParam || originalQuestionIdParam);
        }
    }, []);

    useEffect(() => {
        posthog.capture('$pageview', {
            $current_url: window.location.href,
            $host: window.location.hostname,
            $pathname: window.location.pathname,
        });
    }, []);

    useEffect(() => {
        const getUser_ = async () => {
            let curUser = await GetUser(isSignedIn, user);
            if (curUser["firstName"]) {
                setCandidateFirstName(curUser["firstName"])
                setCandidateLastName(curUser["lastName"])
                setHasTwoInterviewsThisMonth(curUser["hasTwoInterviewsThisMonth"])
            }
            if (curUser) {
                setIsPremium(curUser.premium || false)
                setSubscriptionLevel(curUser.subscriptionLevel || 'Free Starter')
                setPartner(curUser.partner || null)
            }
        }

        if (isSignedIn) {
            setCandidateImg(user.imageUrl);
            setCandidateEmail(user.primaryEmailAddress.emailAddress);
            posthog.identify(user.primaryEmailAddress.emailAddress);
            // set candidate name
            getUser_();
        }
    }, [isSignedIn])

    // Handle different interview modes
    useEffect(() => {
        const initializeInterview = async () => {
            if (isPracticeMode) {
                await handlePracticeMode();
            } else {
                await handleQuickMock();
            }
        };

        if (isLoaded) {
            initializeInterview();
        }
    }, [isPracticeMode, isB2BInterview, jobListingId, isLoaded]);

    useEffect(() => {
        posthog.capture('$pageview', {
            $current_url: window.location.href,
            $host: window.location.hostname,
            $pathname: window.location.pathname,
        });
    }, []);

    const handleQuickMock = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const QMJid = urlParams.get('QMJid');
        const sessionIdParam = urlParams.get('sessionId');
        const pluginJD = urlParams.get('pluginJD');
        const companyName = urlParams.get('companyName');
        const companyLogoURL = urlParams.get('companyLogoURL');
        const jobTitle = urlParams.get('jobTitle');
        const roundParam = urlParams.get('round');
        const languageParam = urlParams.get('language');
        const jobParam = urlParams.get('job');
        if (jobParam) {
            setJobId(jobParam);
        }



        // Handle B2B interview data fetching 
        if (isB2BInterview && jobListingId) {
            try {
                const response = await axios.get(`${process.env.REACT_APP_B2B_BACKEND_URL}/applications/${jobListingId}/interview-details`);

                const jobData = response.data;

                setGlobalRound('');
                setJT(jobData.jobTitle);
                setCN(jobData.companyName);
                setGlobalJD(jobData.jobDescription);

                // if (jobData.voiceId) {
                //     setAgentId(jobData.voiceId);
                // }

                // Store the jobListingId in sessionStorage for later use
                sessionStorage.setItem('jobListingId', jobListingId);
            } catch (error) {
                console.error("Failed to fetch B2B job details:", error);
            }
        } else if (QMJid) {
            setQuickMockJobId(QMJid);
            setGlobalRound('Quick Mock');
            setJT(jobTitle);
            setCN(companyName);
        } else if (sessionIdParam) {
            setSessionId(sessionIdParam);
            setGlobalRound('Quick Mock');
            setJT(jobTitle);
            setCN(companyName);
        } else if (pluginJD) {
            setGlobalRound('Quick Mock');
            setJT(jobTitle);
            setCN(companyName);

            const dataToSend = {
                jobdescription: pluginJD,
                companyName: companyName || "none",
                companyLogoURL: companyLogoURL || "none",
                jobTitle: jobTitle || "none",
            };
            const headers = {
                'Content-Type': 'application/json',
            }
            const url = process.env.REACT_APP_BACKEND_URL + "/api/openai/generateSystemPrompt";
            console.log('[INFO] Fetching system prompt generation');

            try {
                const response = await axios.post(url, dataToSend, { headers });
                const { quickMockJobId: fetchedQMJid, message } = response.data;
                if (fetchedQMJid) {
                    setQuickMockJobId(fetchedQMJid);
                    updateURLWithQMJid(fetchedQMJid);
                    setJT(jobTitle);
                    setCN(companyName);
                }
            } catch (error) {
                console.error(error);
            }
        } else {
            if (roundParam) {
                console.log("roundParam is:", roundParam);
                setGlobalRound(roundParam);
            }
        }

        if (languageParam) {
            setLanguage(languageParam);
        }
        if (companyName) {
            setCN(companyName);
        }
        if (jobTitle) {
            setJT(jobTitle);
        }
    };

    useInterval(async () => {
        if (sessionId && !jobDataReady) {

            const url = process.env.REACT_APP_BACKEND_URL + "/api/userData/JobStatus";
            const dataToSend = {
                sessionId: sessionId,
            };

            try {
                console.log(url, dataToSend);
                const response = await axios.post(url, {
                    sessionId: sessionId,
                });
                if (response.data && response.data.quickMockJobId) {
                    setQuickMockJobId(response.data.quickMockJobId);
                    setJT(response.data.jobTitle);
                    setCN(response.data.companyName);
                    setJobDataReady(true);
                }
            } catch (error) {
                console.error('[ERROR] Error while checking job data readiness:', error);
            }
        }
    }, 1000);

    useEffect(() => {
        const createAgent = async () => {
            if (quickMockJobId && !agentId && jobDataReady && false) {

                try {
                    const apiUrl = process.env.REACT_APP_BACKEND_URL + "/api/elevenlabs/createAgent";

                    const response = await axios.post(apiUrl, {
                        jobData: {
                            id: quickMockJobId,
                            company: cN,
                            position: jT
                        }
                    });

                    if (response.data.agentId) {
                        setAgentId(response.data.agentId);
                        updateURLWithQMJid(quickMockJobId, response.data.agentId);
                    }
                } catch (error) {
                    console.error('Agent create fail:', error);
                    posthog.capture('agent_creation_failed', {
                        error: error.message
                    });
                }
            } else if (quickMockJobId) {
                updateURLWithQMJid(quickMockJobId, agentId);
            }
        };

        createAgent();

    }, [jobDataReady]);


    if (!globalRound && !isB2BInterview) {
        return (
            <CreateInterview
                setInterview={(resume, jd, round) => {
                    setGlobalResume(resume);
                    setGlobalJD(jd);
                    setGlobalRound(round);
                }}
                isB2BInterview={isB2BInterview}
            />
        )
    } else if (isB2BInterview && !globalRound) {
        return (
            <CreateInterview
                setInterview={(resume, jd, round) => {
                    setGlobalResume(resume);
                    setGlobalJD(isB2BInterview ? globalJD : jd);
                    setGlobalRound(round);
                }}
                isB2BInterview={isB2BInterview}
            />
        )
    } else {
        return (
            <>
                <Helmet>
                    <title>{TITLE}</title>
                </Helmet>
                {!hasUserJoined &&
                    <>
                        <TopBar />
                        <WaitingRoom
                            isVideoOnGlobal={video}
                            setVideoGlobal={setVideo}
                            isMicOnGlobal={mic}
                            setMicGlobal={setMic}
                            setHasUserJoined={setHasUserJoined}
                            round={globalRound}
                            candidate={candidateFirstName}
                            candidateImg={candidateImg}
                            language={language}
                            quickMockJobId={quickMockJobId}
                            companyName={cN}
                            jobTitle={jT}
                            isSignedIn={isSignedIn}
                            hasTwoInterviewsThisMonth={isB2BInterview ? false : hasTwoInterviewsThisMonth}
                            setJoinTime={setJoinTime}
                            isB2BInterview={isB2BInterview}
                            jobId={jobId}
                            isPracticeMode={isPracticeMode}
                            practiceQuestion={practiceQuestion?.interviewQuestion}
                            practiceQuestionType={practiceQuestion?.standardizedQuestionType}
                            practiceInterviewRound={practiceQuestion?.interviewType}
                            practiceDifficulty={practiceQuestion?.difficulty}
                            isPremium={isPremium}
                        />
                    </>
                }
                {
                    hasUserJoined && !hasEndButtonClicked &&
                    <>
                        <MainScreen
                            isVideoOn={video}
                            isMicOn={mic}
                            isccOn={cc}
                            isIntvSpeaking={isIntvSpeaking}
                            isCandSpeaking={isCandSpeaking}
                            candidateImg={candidateImg}
                            candidate={candidateFirstName}
                        />
                        <SpeechToText
                            isMicOn={mic}
                            isccOn={cc}
                            resume={globalResume}
                            jd={globalJD}
                            candidate={candidateFirstName}
                            round={globalRound}
                            language={language}
                            setIntvSpeaking={setIsIntvSpeaking}
                            setCandSpeaking={setIsCandSpeaking}
                            setInterviewPrompt={(id, question) => {
                                setInterviewPromptId(id);
                                setInterviewQuestion(question);
                            }}
                            quickMockJobId={quickMockJobId}
                            agentId={agentId}
                            isB2BInterview={isB2BInterview}
                            jobListingId={jobListingId}
                            isPracticeMode={isPracticeMode}
                            practiceQuestion={practiceQuestion}

                        />
                        <Footer
                            isVideoOn={video}
                            isMicOn={mic}
                            onMicClick={setMic}
                            onVideoClick={setVideo}
                            onccClick={setCc}
                            hasUserJoined={hasUserJoined}
                            candidateEmail={candidateEmail}
                            round={globalRound}
                            interviewPromptId={interviewPromptId}
                            interviewQuestion={interviewQuestion}
                            hasEndButtonClicked={hasEndButtonClicked}
                            setEndButtonClicked={setEndButtonClicked}
                            quickMockJobId={quickMockJobId}
                            joinTime={joinTime}
                            agentId={agentId}
                            isB2BInterview={isB2BInterview}
                            jobListingId={jobListingId}
                            candidateFirstName={candidateFirstName}
                            candidateLastName={candidateLastName}
                            resumeData={globalResume}
                            partner={partner}
                        />
                    </>
                }
                {
                    hasEndButtonClicked &&
                    <>
                        {!isB2BInterview && (
                            <CompleteInterview
                                isB2BInterview={isB2BInterview}
                                jobListingId={jobListingId}
                                candidateEmail={candidateEmail}
                                resumeData={globalResume}
                                candidateFirstName={candidateFirstName}
                                candidateLastName={candidateLastName}
                            />
                        )}
                        <Footer
                            isVideoOn={video}
                            isMicOn={mic}
                            onMicClick={setMic}
                            onVideoClick={setVideo}
                            onccClick={setCc}
                            hasUserJoined={hasUserJoined}
                            candidateEmail={candidateEmail}
                            round={globalRound}
                            interviewPromptId={interviewPromptId}
                            interviewQuestion={interviewQuestion}
                            hasEndButtonClicked={hasEndButtonClicked}
                            setEndButtonClicked={setEndButtonClicked}
                            joinTime={joinTime}
                            isB2BInterview={isB2BInterview}
                            jobListingId={jobListingId}
                            candidateFirstName={candidateFirstName}
                            candidateLastName={candidateLastName}
                            resumeData={globalResume}
                            partner={partner}
                        />
                    </>
                }
            </>
        );
    }
}

export default Interview;